<template>
		<main class="main-wrapper flex-grow-1">
			<div class="d-flex align-items-center bg-white">
				<div class="t-headline13 t-color-headlineBlack pda-14 flex-grow-1 bg-white fix-header-title d-flex align-items-center justify-content-center font-m">
					{{$t('3244')}}
				</div>                                                                                  
			</div>
			<div class="divider"></div>
			<div class="container container--narrow">
					<form @submit.prevent="addProducts()" novalidate>
						<div class="pdt-50">
						<div class="d-flex">
							<div class="edm-upload pdr-40" v-if="details && details.thumbnail && details.thumbnail.resourceUri">
								<img :src="details.thumbnail.resourceUri" alt="" class="b-radius4">
							</div>
							<div class="flex-grow-1">
								<div class="t-body3 t-line-h-22 t-color-bodyGrayA  font-r" v-if="details">{{details ? details.hcategoryNames:''}}</div>
								<div class="t-headline13 l-spacing66 t-line-h-34 mgt-1 font-m" v-if="details">{{details ? details.name:''}}</div>
								<div class="t-body6 t-color-bodyGrayB t-line-h-20 mgt-16 l-spacing105 font-r">{{details ? details.barcode:''}}</div>
								<div class="t-body1 t-color-bodyGrayA l-spacing48 t-line-h-22 font-r mgt-16" v-if="details && details.description" >{{details && details.description? details.description:''}}</div>
							</div>
						</div>
						<!-- <div class="t-body3 font-r t-color-bodyGrayA t-line-h-22 l-spacing42 pdl-16 pdr-16" v-if="details && details.description" >{{details && details.description? details.description:''}}</div> -->
						<div class="divider mgt-28"></div>
						<div class="t-subtitle5 font-m t-line-h-33 mgt-28" >{{$t('3246')}}</div>
						<div class="t-body1 t-color-bodyGrayA t-line-h-24 mgt-4 font-r">
							{{$t('3247')}}<br>
							{{$t('3300')}}
						</div>
			<div class="mgt-28">
				
				<label class="mdc-text-field mdc-text-field--outlined mdc-text-field--with-trailing-icon w-full customize-input h-46"
					:class="submitState && receivingDateInvalidCheck ? 'mdc-text-field--invalid' : receivingDate !==''?'textFieldVal':''"
					id="receivingDateEl"
				>
					<!-- <i class="material-icons mdc-text-field__icon">
						{{receivingDateValidIcon}}
					</i> -->
					<input type="text" class="mdc-text-field__input"
						v-model="receivingDate"
						v-validate="'required|min:1'"
						ref="receivingDate"
						id="receivingDate"
						name="receivingDate"
						maxlength="8"
						@keyup="checkRecValidation($event)"
					>
					<i class="material-icons mdc-text-field__icon mdc-text-field__icon--trailing d-none" tabindex="0"
      role="button" :class="receivingDateValidIcon == 'check' ? 'check_show' : ''">	{{receivingDateValidIcon}}</i>
					<div class="mdc-notched-outline">
						<div class="mdc-notched-outline__leading"></div>
						<div class="mdc-notched-outline__notch">
						<label for="tf-outlined" class="mdc-floating-label">
							{{$t('3248')}}
						</label>
						</div>
						<div class="mdc-notched-outline__trailing"></div>
					</div>
				</label>
				<div class="t-helper mgl-7 mgr-7 pdt-2 min-h-23" :class="submitState && receivingDateInvalidCheck  ? 't-color-mainBtn' : 't-color-textfieldActive'">
					<span>
						<!-- {{submitState && receivingDateInvalidCheck && receivingDateValidation==false? $t('3262') : submitState && receivingDateValidation? $t('3264'):$t('3249')}} -->
						
						{{submitState && receivingDateInvalidCheck && receivingDateLengthValidation==false && receivingDateValidation==false? $t('3262') : submitState && receivingDateLengthValidation? $t('3249'):submitState && receivingDateValidation?$t('3264'):$t('3249')}}
					</span>
				</div>
				
			</div>
	   
			<div class="mgt-30">
				<label class="mdc-text-field mdc-text-field--outlined mdc-text-field--with-trailing-icon w-full customize-input h-46"
					:class="submitState && expirationDateInvalidCheck ? 'mdc-text-field--invalid' :  expirationDate !==''?'textFieldVal':''"
					id="expirationDateEl"
				>
					<!-- <i class="material-icons mdc-text-field__icon">
						{{expirationDateValidIcon}}
					</i> -->
					<input type="text" class="mdc-text-field__input"
						v-model="expirationDate"
						v-validate="'required|min:1'"
						ref="expirationDate"
						id="expirationDate"
						name="expirationDate"
						maxlength="8"
						@keyup="checkExpValidation($event)"
					>
					<i class="material-icons mdc-text-field__icon mdc-text-field__icon--trailing d-none" tabindex="0"
      role="button" :class="expirationDateValidIcon == 'check' ? 'check_show' : ''">	{{expirationDateValidIcon}}</i>
					<div class="mdc-notched-outline">
						<div class="mdc-notched-outline__leading"></div>
						<div class="mdc-notched-outline__notch">
						<label for="tf-outlined" class="mdc-floating-label">
							{{$t('3250')}}
						</label>
						</div>
						<div class="mdc-notched-outline__trailing"></div>
					</div>
					
				</label>
				<div class="t-helper mgl-7 mgr-7 pdt-2 min-h-23" :class="submitState && expirationDateInvalidCheck ? 't-color-mainBtn' : 't-color-textfieldActive'">
					<span>
						<!-- {{$t('3265')}}
						expirationDateValidation -->
						<!-- {{submitState && expirationDateInvalidCheck && expirationDateValidation==false? $t('3263') : submitState && expirationDateValidation? $t('3265'):$t('3251')}} -->
						{{submitState && expirationDateInvalidCheck && expirationDateLengthValidation==false && expirationDateValidation==false? $t('3263') : submitState && expirationDateValidation? $t('3266'):submitState && expirationDateLengthValidation?$t('3251'):$t('3251')}}
						<!-- {{submitState && expirationDateInvalidCheck ? $t('3263') : $t('3251')}} -->
					</span>
				</div>
				
			</div>
			<div class="mgt-30">
				<label class="mdc-text-field mdc-text-field--outlined mdc-text-field--with-trailing-icon w-full customize-input h-46"
					:class="submitState && productQuantityInvalidCheck ? 'mdc-text-field--invalid' : productQuantity !==''?'textFieldVal':''"
					id="productQuantityEl"
				>
					<!-- <i class="material-icons mdc-text-field__icon">
						{{productQuantityValidIcon}}
					</i> -->
					<input type="text" class="mdc-text-field__input"
						v-model="productQuantity"
						v-validate="'required|min:1'"
						ref="productQuantity"
						id="productQuantity"
						name="productQuantity"
						maxlength="40"
					>
					<i class="material-icons mdc-text-field__icon mdc-text-field__icon--trailing d-none" tabindex="0"
      role="button" :class="productQuantityValidIcon == 'check' ? 'check_show' : ''">	{{productQuantityValidIcon}}</i>
					<div class="mdc-notched-outline">
						<div class="mdc-notched-outline__leading"></div>
						<div class="mdc-notched-outline__notch">
						<label for="tf-outlined" class="mdc-floating-label">
							{{$t('3252')}}
							
						</label>
						</div>
						<div class="mdc-notched-outline__trailing"></div>
					</div>
					
				</label>
				<div class="t-helper mgl-7 mgr-7 pdt-2 min-h-23" :class="submitState && productQuantityInvalidCheck ? 't-color-mainBtn' : 't-color-textfieldActive'">
					<span>
						{{$t('3253')}}
						<!-- {{submitState && newPasswordInvalidCheck ? $t('3253') : $t('3253')}} -->
						
						
					</span>
				</div>

				<!-- <div class="t-helper mgl-7 mgr-7 t-color-mainBtn">
					<span v-show="submitState && productQuantityInvalidCheck">{{$t('3253')}}</span>
				</div> -->
			</div>

		   
		<div>
			<div class="divider mgt-28" v-if="checkedList.length>0"></div>
			<div class="t-subtitle5 font-m t-line-h-33 mgt-28" v-if="checkedList.length>0">
			   {{$t('3254')}}
			</div>
			<div v-for="(checklist,index) in checkedList" :key="index">
				<div class="t-body1 t-color-headlineBlack t-line-h-22 l-spacing42 mgt-16 font-r">
					{{++index}}. {{checklist.checklistItem}}
				</div>
				<div class="d-flex">
					<div class="mdc-form-field mgr-24 mgt-14">
						<div class="mdc-radio mdc--radio__custom ">
							
							<input class="mdc-radio__native-control" type="radio" id="radio-1" v-model="checklist.answer" :name="'answer'+index" value="true" :checked="checklist.answer == 'true'">
							<div class="mdc-radio__background">
								<div class="mdc-radio__outer-circle"></div>
								<div class="mdc-radio__inner-circle"></div>
							</div>
							<div class="mdc-radio__ripple"></div>
						</div>
						<div for="radio-1" class="t-body1 font-r min-w-47 pdl-14 pdb-4">{{$t('3274')}}</div>
					</div>
					<div class="mdc-form-field mgr-24  mgt-14">
						<div class="mdc-radio mdc--radio__custom">
							<input class="mdc-radio__native-control" type="radio" id="radio-1"  v-model="checklist.answer" :name="'answer'+index" value="false" :checked="checklist.answer == 'false'">
							<div class="mdc-radio__background">
								<div class="mdc-radio__outer-circle"></div>
								<div class="mdc-radio__inner-circle"></div>
							</div>
							<div class="mdc-radio__ripple"></div>
						</div>
						<div for="radio-1" class="t-body1 font-r min-w-47 pdl-14 pdb-4">{{$t('3275')}}</div>
					</div>
				</div>
			</div>
			<div class="divider mgt-28 mgb-28"></div>
			<div class="t-subtitle2 font-b">
				{{$t('3295')}}
			</div>
			<div class="t-body3 t-color-bodyGrayA t-line-h-22 l-spacing42 mgt-4 font-r">
				{{$t('3296')}}
			</div>
					<label for="file" v-if="image == null || image.resourceUri==''">
					<input
						type="file"
						id="commentFileUpload"
						:accept="allowExt()"
						@change="uploadFile"
						class="d-none"
					/>
						<div @click="openFileUpload(true,true)" @keypress="openFileUpload(true,true)" tabindex="0"
						 	class="mgt-24 imageAttachedPlaceHolder d-inline-flex justify-content-center align-items-center b-radius4 bg-contentBlueInactive flex-column position-relative">
								<div><i class="material-icons w-28 h-28 font-28 t-color-contentBlueMedium">add</i></div>
								<div class="t-helper t-color-contentBlueMedium">{{ $t('3297') }}</div>
							</div>
						</label>
					
						<div
						   v-if="image && image.resourceUri"
										class="mgt-24 imageAttachedPlaceHolder d-inline-flex justify-content-center align-items-center b-radius4 bg-contentBlueInactive flex-column position-relative">
										<input
											type="file"
											id="commentFileUpload"
											:accept="allowExt()"
											@change="uploadFile"
											class="d-none"
										/>
										<div><img :src="image.resourceUri" @click="openFileUpload(true,true)" @keypress="openFileUpload(true,true)" alt="" tabindex="0">
														<span class="remove-img remove-edm-image position-absolute t-color-white" @click="removeProductImage" @keypress="removeProductImage" tabindex="0"><i
																		class="material-icons t-body1">close</i></span>
										</div>
										<!-- <div class="t-helper t-color-contentBlueMedium">Add photo</div> -->
						</div>
		</div>
		 <div class="mgt-50 pdb-34">
				<!-- <button class="mdc-button mdc-button--raised btn-red mr8">
					{{$t('336')}}
				</button> -->
				<button class="mdc-button mdc-button--raised bg-mainBtn t-color-mainBtnText b-radius4 mgr-8">
				<div class="mdc-button__ripple"></div>
				<span class="mdc-button__label t-body3 font-r">{{$t('3260')}}</span>
			</button>
				<button class="mdc-button  t-color-secondaryBtnText b-radius4 mgr-8" @click.prevent="goToSearch" @keypress.prevent="goToSearch" tabindex="0">
				<div class="mdc-button__ripple"></div>
				<span class="mdc-button__label t-body3 font-r">{{$t('3261')}}</span>
			</button>
			</div>
						</div>
	</form>
				</div>
		</main>
	
</template>

<script>
import {MDCTextField} from '@material/textfield'
import {MDCRipple} from '@material/ripple'
import storeApi from '@/api/storeMgtApi.js'
import { commonMixin } from "@/mixins/common.js";

export default {
	data() {
		return {
			details: null,
			checkedList:[],
			receivingDate: '',
			expirationDate: '',
			productQuantity: '',
			receivingDateTextField: null,
			expirationDateTextField: null,
			productQuantityTextField: null,
			submitState: false,
			receivingDateValidIcon: '',
			expirationDateValidIcon: '',
			productQuantityValidIcon: '',
			params : "",
			// receivingDate:null,
			// expirationDate:null,
			stockReceivingDate:null,
			stockExpirationDate:null,
			stock:'',
			image: null,
			todayDate:this.$moment(new Date()).format('YYYY-MM-DD').valueOf(),
			receivingDateValidation:false,
			receivingDateLengthValidation:false,
			expirationDateValidation:false,
			expirationDateLengthValidation:false,
			checkCheckedList: false
		}
	},
	
	mixins: [commonMixin],

	computed : {
		receivingDateInvalidCheck() {
			let returnValue = false
			if (this.submitState) {
				// this.receivingDateValidation = false
				// this.receivingDateLengthValidation = false
				let tDate = this.$moment(new Date()).format('YYYY-MM-DD')
				let tDateConvertMiliSecond = this.$moment(tDate).valueOf()
				let recDate = this.$moment(this.receivingDate).format('YYYY-MM-DD')
				let recDateConvertMiliSecond = this.$moment(recDate).valueOf()

				if (this.errors.has('receivingDate')) {
					returnValue = true
					this.receivingDateValidIcon = 'warning'
				}else if(this.receivingDate.length<8) {
					returnValue = true
					this.receivingDateLengthValidation = true
					this.receivingDateValidIcon = 'warning'
				}else if(recDateConvertMiliSecond>tDateConvertMiliSecond) {
					returnValue = true
					this.receivingDateValidation = true
					this.receivingDateValidIcon = 'warning'
				}else {
					returnValue = false
					this.receivingDateValidIcon = 'check'
				}
			}
			this.receivingDateTextField.valid === !returnValue ? '' : this.receivingDateTextField.valid = !returnValue
			return returnValue
		},

		expirationDateInvalidCheck() {
			let returnValue = false
			if (this.submitState) {
				// this.expirationDateValidation = false
				// this.expirationDateLengthValidation = false
				// let tDate = this.$moment(new Date()).format('YYYY-MM-DD')
				// let tDateConvertMiliSecond = this.$moment(tDate).valueOf()
				let recDate = this.$moment(this.receivingDate).format('YYYY-MM-DD')
				let recDateConvertMiliSecond = this.$moment(recDate).valueOf()
				let expDate = this.$moment(this.expirationDate).format('YYYY-MM-DD')
				let expDateConvertMiliSecond = this.$moment(expDate).valueOf()

				if (this.errors.has('expirationDate')) {
					returnValue = true
					this.expirationDateValidIcon = 'warning'
				}else if(this.expirationDate.length<8) {
					returnValue = true
					this.expirationDateLengthValidation = true
					this.expirationDateValidIcon = 'warning'
				}else if(expDateConvertMiliSecond<recDateConvertMiliSecond) {
					returnValue = true
					this.expirationDateValidation = true
					this.expirationDateValidIcon = 'warning'
				}else {
					returnValue = false
					this.expirationDateValidIcon = 'check'
				}
			}
			this.expirationDateTextField.valid === !returnValue ? '' : this.expirationDateTextField.valid = !returnValue
			return returnValue
		},

		productQuantityInvalidCheck() {
			let returnValue = false
			if (this.submitState) {
				if (this.errors.has('productQuantity')) {
					returnValue = true
					this.productQuantityValidIcon = 'warning'
				}else {
					returnValue = false
					this.productQuantityValidIcon = 'check'
				}
			}
			this.productQuantityTextField.valid === !returnValue ? '' : this.productQuantityTextField.valid = !returnValue
			return returnValue
		},

	},

	mounted() {
		let params = {
		   
			goodsId: this.$route.params.goodsId
		}
		 //console.log(this.$route.params)
		this.$showLoading();
		storeApi.storeGoodsId(params).then((response) => {
			this.details = response.data.data
			//this.checkedList= this.details?this.details.checkList:''
			let checkedListAnswer= this.details?this.details.checkList:''
				if(checkedListAnswer){
					for (let checkedListAns in checkedListAnswer) {
						Object.assign(checkedListAnswer[checkedListAns], {answer: ''})
					}
				}
			
			this.checkedList=checkedListAnswer
		//	console.log('checkedList', this.checkedList)
			this.$hideLoading();
		}).catch(err => {
		  this.$hideLoading();
		});


		this.setInputFilter(document.getElementById("receivingDate"), function(value) {
			return /^\d*$/.test(value); 
		});
		this.setInputFilter(document.getElementById("expirationDate"), function(value) {
			return /^\d*$/.test(value); 
		});
		// this.setInputFilter(document.getElementById("productQuantity"), function(value) {
		//     return /^\d*$/.test(value); 
		// });
				this.setMaterialUi()
		 this.$refs.receivingDate.focus()

	},
	
	methods: {
		setMaterialUi() {
			this.receivingDateTextField = new MDCTextField(document.querySelector('#receivingDateEl'))
			this.receivingDateTextField.useNativeValidation = false
			this.expirationDateTextField = new MDCTextField(document.querySelector('#expirationDateEl'))
			this.expirationDateTextField.useNativeValidation = false
			this.productQuantityTextField = new MDCTextField(document.querySelector('#productQuantityEl'))
			this.productQuantityTextField.useNativeValidation = false

			const buttonRipple = [].map.call(document.querySelectorAll('.mdc-button'), function(el) {
				let button = new MDCRipple.attachTo(el)
				return button
			})
		},

		setInputFilter(textbox, inputFilter) {
			["input", "keydown", "keyup", "mousedown", "mouseup", "select", "contextmenu", "drop"].forEach(function(event) {
				textbox.addEventListener(event, function() {
				if (inputFilter(this.value)) {
					this.oldValue = this.value;
					this.oldSelectionStart = this.selectionStart;
					this.oldSelectionEnd = this.selectionEnd;
				} else if (this.hasOwnProperty("oldValue")) {
					this.value = this.oldValue;
					this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
				} else {
					this.value = "";
				}
				});
			});
		},
		uploadFile(evt) {
			if (!evt.target.files[0]) return;
				this.$showLoading();
				storeApi
					.upload(evt.target.files[0])
					.then(response => {
					this.$hideLoading();
						this.image = response.data.data[0];
					})
					.catch(err => {
					this.$hideLoading();
					this.$error({ content: err.errMsg }).then(() => {});
				});
		},

		openFileUpload(allowImg,type) {
			this.uploadTypeImg = allowImg;
			this.type = type
			setTimeout(() => {
				document.getElementById("commentFileUpload").click();
			}, 0);
		},

		allowExt() {
			return this.type ? "image/jpeg,image/png" : "image/jpeg,image/png";
		},

		removeProductImage() {
			this.image=null
		},
		addProducts() {
			this.$showLoading();
			this.$validator.validateAll().then((resultValid) => {
				this.submitState = true
				let recDate = this.$moment(this.receivingDate).format('YYYY-MM-DD')
				let expDate = this.$moment(this.expirationDate).format('YYYY-MM-DD')
				// let addAnswerKey = this.checkedList.map((element,index)=>{
				//     return Object.assign(element[index], {answer: false})
				// })
				// this.checkedList=addAnswerKey
				if(this.checkedList.length>0){
					this.checkedList.filter((element) => { 
						if(element.answer==''){
							this.$snackOpen({contents: this.$t('3327') , btnDisplay:'',timeoutMs:4000}).then(() => {})
							this.checkCheckedList=false
							return false
						} else {
							this.checkCheckedList=true
						}
					})
				} else {
					this.checkCheckedList=true
				}
				

				// let checkKeyPresenceInArray = key => this.checkedList.some(obj => Object.keys(obj).includes(key));
				// let isKeyPresent = checkKeyPresenceInArray('answer')
				// if(isKeyPresent==false) {
				//     this.$snackOpen({contents: this.$t('3327') , btnDisplay:'',timeoutMs:4000}).then(() => {})
				//     return false
				// }
				// console.log(isKeyPresent);
				
					if (resultValid && this.receivingDateLengthValidation=== false && this.receivingDateValidation===false && this.expirationDateValidation===false && this.expirationDateLengthValidation===false && this.checkCheckedList==true) {
							let params = {
							"id" : this.$route.params.goodsId,
							//"store": this.details.store,
							"goods": this.details,
							"checkedList" : this.checkedList,
							"stock" : this.productQuantity,
							"receivingDate" : (this.$moment(recDate).valueOf()),
							"expirationDate" : (this.$moment(expDate).valueOf()),
							"image" : this.image,
							"auditor": this.details.auditor,
						}
					//console.log('params=>',params)
						
						storeApi.storeProductAdd(params).then((response)=>{
							this.$hideLoading();
							this.$router.push({
								name: 'StoreView',
								params: {goodsId: response.data.data.id},
							})
						}).catch((err) => {
							this.$hideLoading();
							console.log(err.response)                        
							responseData = err.response.data.meta
							let errMsg = this.$t(`system.err.${responseData.errCode}`)
							this.$error({content: errMsg}).then(() => {
								this.$hideLoading();
								// this.$router.push({
                				// 	name: 'StoreManagement',
            					// })
							})
                		}) ;
					} else {
						//this.submitState = false
					}
			})

			this.$hideLoading();
			
		},

		checkRecValidation(evt) {
			let tDate = this.$moment(new Date()).format('YYYY-MM-DD')
			let tDateConvertMiliSecond = this.$moment(tDate).valueOf()
			let recDate = this.$moment(evt.target.value).format('YYYY-MM-DD')
			let recDateConvertMiliSecond = this.$moment(recDate).valueOf()
			//console.log('evt.target.value',this.receivingDate.length)
			if(this.receivingDate.length<8) {
				this.receivingDateLengthValidation = true
				this.receivingDateValidation = false
			}else if(recDateConvertMiliSecond>tDateConvertMiliSecond) {
				this.receivingDateValidation = true
				this.receivingDateLengthValidation = false
			}else {
				this.receivingDateLengthValidation = false
				this.receivingDateValidation = false
			}
		},

		checkExpValidation(evt) {
			let recDate = this.$moment(this.receivingDate).format('YYYY-MM-DD')
			let recDateConvertMiliSecond = this.$moment(recDate).valueOf()
			let expDate = this.$moment(evt.target.value).format('YYYY-MM-DD')
			let expDateConvertMiliSecond = this.$moment(expDate).valueOf()
			//console.log('evt.target.value',this.receivingDate.length)
			if( this.expirationDate.length<8) {
				this.expirationDateLengthValidation = true
				this.expirationDateValidation = false
			} else if( recDateConvertMiliSecond && expDateConvertMiliSecond<recDateConvertMiliSecond) {
				this.expirationDateValidation = true
				this.expirationDateLengthValidation = false
			} else {
				this.expirationDateLengthValidation = false
				this.expirationDateValidation = false
			}
		},
		goToSearch() {
			this.$router.push({
				name: 'StoreProductCategory',
			})
		},
		
	}
}
</script>

<style scoped>
	
	.imagePlaceHolder{
		width: 104px;
		height: 104px;
	}

	.imageWrapper{
		/* max-height: 100px; */
		display: flex;
	}
	.img-thumbnail{
		width: 104px;
	}
	.img-thumbnail img{
		border-radius: 4px;
		width: 104px;
		height: 104px;
		object-fit: cover;
	}
 
	
	.img-border{
		margin-bottom: -4px !important;
	}
	.closeIcon {
		top: -8px;
		right: -8px;
		border-radius: 50%;
		width: 24px;
		height: 24px;
		background: var(--Iconinactive);
		display: flex;
		justify-content: center;
		align-items: center;
		border: 3px solid var(--DocumentWhite);
		color: var(--DocumentWhite);
		line-height: 0px;
	}
	html[dir="rtl"] .closeIcon {
		left: -8px;
	}
	.check_show{
		display:block;
	}
	.mdc-text-field--outlined.textFieldVal:not(.mdc-text-field--disabled) .mdc-notched-outline__leading, .mdc-text-field--outlined.textFieldVal:not(.mdc-text-field--disabled) .mdc-notched-outline__notch, .mdc-text-field--outlined.textFieldVal:not(.mdc-text-field--disabled) .mdc-notched-outline__trailing{
		border-color: var(--Textfeildactive) !important;
	}
</style>
